var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{staticStyle:{"border":"1px solid #ccc","padding":"10px","border-radius":"4px"},attrs:{"size":"small","bordered":true}},[_c('template',{slot:"title"},[_c('span',{staticStyle:{"margin-right":"4px"}},[_vm._v("CI覆盖率")])]),_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.id}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }